export default {
  'Представитель с правом подписи приказа': 'Əmri imzalamaq hüququ olan nümayəndə',
  'Откройте компанию → Сотрудники → Права подписи': 'Təşkilatı açın → Əməkdaşlar → İmza hüquqları',
  'Годовые планы': 'İllik planlar',
  'Разделы профиля': 'Profil bölmələri',
  'Нет результатов проверки': 'Yoxlama nəticələri yoxdur',
  'Не удалось получить результаты. Повторите проверку.': 'Nəticələri almaq mümkün olmadı. Yoxlamanı təkrarlayın.',
  'Текущие и завершённые аудиты, доступные вам для просмотра.': 'Baxış üçün sizə açıq olan cari və tamamlanmış auditlər.',
  'Право редактирования конкретного аудита зависит от назначения в его команду.': 'Konkret auditi redaktə etmək hüququ onun komandasına təyinatdan asılıdır.',
  'JPEG, PNG или WebP, до 250 КБ.': 'JPEG, PNG və ya WebP, 250 KB-a qədər.',
  'Представитель организации': 'Təşkilatın nümayəndəsi',
  'Историческая запись — ещё не связана с учётной записью': 'Tarixi qeyd — hələ istifadəçi hesabı ilə əlaqələndirilməyib',
  'Оставить историческую запись без привязки': 'Tarixi qeydi əlaqələndirmədən saxla',
  'Права подписи сохранены. Ранее оформленные документы не изменены.': 'İmza hüquqları yadda saxlanıldı. Əvvəllər hazırlanmış sənədlər dəyişdirilmədi.',
  'Администратор назначает права на приказы, акты и ПКПД. Старые записи сохранены; при необходимости свяжите их с представителем вручную.': 'Administrator əmrlər, aktlar və düzəldici tədbirlər planlarını imzalamaq hüquqlarını təyin edir. Köhnə qeydlər saxlanılıb; lazım olduqda onları nümayəndə ilə əl ilə əlaqələndirin.',
  'Планы аудитов': 'Audit planları',
  'Отчёты по аудитам': 'Auditlər üzrə hesabatlar',
  'Карточка аудитора': 'Auditorun profili',
  'Фото аудитора': 'Auditorun fotosu',
  'Убрать фото': 'Fotonu sil',
  'Аудиты сотрудника': 'Əməkdaşın auditləri',
  'В работе и запланированы': 'Davam edən və planlaşdırılmış',
  'Завершены и отменены': 'Tamamlanmış və ləğv edilmiş',
  'Нет аудитов': 'Audit yoxdur',
  'Права и доступ': 'Hüquqlar və giriş',
  'Управление учётной записью': 'Hesabın idarə edilməsi',
  'Представители и право подписи': 'Nümayəndələr və imza hüququ',
  'Настроить права': 'Hüquqları tənzimlə',
  'Назначить право подписи представителю': 'Nümayəndəyə imza hüququ ver',
  'Сохранить права подписи': 'İmza hüquqlarını yadda saxla',
  'Права подписи': 'İmza hüquqları',
  'Полномочия включены': 'Səlahiyyətlər aktivdir',
  'Права подписи не выданы': 'İmza hüquqları verilməyib',
  'Действуют': 'Qüvvədədir',
  'Не действуют': 'Qüvvədə deyil',
  'Язык регистрационных писем': 'Qeydiyyat məktublarının dili',
  'Отправить отчёт': 'Hesabatı göndər',
  'Отправка отчёта': 'Hesabatın göndərilməsi',
  'Получатель': 'Alıcı',
  'Проверяем получателей…': 'Alıcılar yoxlanılır…',
  'Что проверить': 'Nəyi yoxlamaq lazımdır',
  'Состояния записей': 'Qeydlərin vəziyyəti',
  'Проверка статусов и документов аудитов': 'Audit statuslarının və sənədlərinin yoxlanılması',
  'В карточке': 'Audit kartında',
  'По документам': 'Sənədlərə əsasən',
  'Введите время от 00:00 до 23:59.': '00:00–23:59 aralığında vaxt daxil edin.',
  'Фото должно быть не больше 250 КБ.': 'Foto 250 KB-dan böyük olmamalıdır.',
  'Профили сотрудников, навыки, опыт и участие в аудитах. Откройте карточку, чтобы посмотреть подробности.': 'Əməkdaşların profilləri, bacarıqları, təcrübəsi və auditlərdə iştirakı. Ətraflı məlumat üçün profili açın.',
  'Проверки сервисов и ошибки, которые требуют внимания администратора.': 'Xidmətlərin yoxlanılması və administratorun diqqətini tələb edən xətalar.',
};
